// Core
import React, { Component, lazy } from 'react';
import { withRouter, Switch, Route } from 'react-router';

// Instruments
import { book } from './book';

// Styles
import 'theme/css/common.css';
import 'theme/css/ext.css';
import 'theme/css/compare.css';
import 'theme/css/tour.css';
import 'theme/css/country.css';

// Pages
const Hotel = lazy(() => import(/* webpackChunkName: "hotel" */'pages/hotel'));
const Search = lazy(() => import(/* webpackChunkName: "search" */'pages/search'));
const CountrySearch = lazy(() => import(/* webpackChunkName: "country-search" */'pages/country/CountrySearch'));
const Main = lazy(() => import(/* webpackChunkName: "main" */'pages/main'));
const Compare = lazy(() => import(/* webpackChunkName: "compare" */'pages/compare'));
const Tours = lazy(() => import(/* webpackChunkName: "tours" */'pages/tours'));
const Playground = lazy(() => import(/* webpackChunkName: "playground" */'pages/playground'));

// Components
import { ScrollToTop } from 'components/molecules';

@withRouter
export default class Routes extends Component {
    render () {
        return (<>
            <ScrollToTop />
            <Switch>
                <Route exact component = { Main } path = { book.mainPage } />
                <Route exact component = { Search } path = { book.searchPage } />
                <Route exact component = { CountrySearch } path = { book.countrySearchPage } />
                <Route component = { Hotel } path = { book.hotelPage } />
                <Route exact component = { Compare } path = { book.comparePage } />
                <Route exact component = { Tours } path = { book.toursPage } />
                <Route exact component = { Playground } path = { book.playgroundPage } />
            </Switch>
        </>);
    }
}
